import { useState, useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { getTaxStructureByTaxTypeID, postTaxStructure } from "../api/fnbAPI";


const StructureModal = (props) => {
    const {taxType} = props

    const [allTaxStructure,    setAllTaxStructure]     = useState([]);
    const [taxStructure,       setTaxStructure]        = useState({TaxTypeID: taxType.ID, Active: "Y"});
    const [isEdit,             setIsEdit]              = useState(false);

    useEffect(() => {
        if(taxType){
            fetchTaxStructureByTaxTypeID(taxType.ID);
        }
    },[taxType]);

    const dataHandler = (field,value) => setTaxStructure(d => ({...d, [field]: value}));

    const editHandler = (id) => {
        setIsEdit(true);
        const d = allTaxStructure.find(a => a.ID == id);
        setTaxStructure(d)
    };

    const postTaxStructureData = async(taxStructure, toggle = true) => {
        const btn  =  (!isEdit) ? $('#btnAdd') : $("#btnUpdate");
        const form = $('#addBlockForm');

        if(toggle){
            form.validate({
                rules: { txtName: { required: true }, txtDescription: { required: true },  txtTax: { required: true }},
                messages: { txtName : { required: "Please enter name" },  txtDescription: {  required: "Please enter decription" }, txtTax : { required: "Please enter tax" }}
            });
    
            if (!form.valid()) return;
        }

        helper.StartProcessing(btn);
        try {
            taxStructure.TaxTypeID = taxType.ID;
            const res = await postTaxStructure(taxStructure);          
            setAllTaxStructure(res);            
            helper.StopProcessing(btn);                  
            if (taxStructure.ID) {            
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Tax Structure updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,  
                    onOpen: () => swal.hideLoading()                                     
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Tax Structure added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()    
                });
                
            }
            
            //Clear State ->
            clearAction();
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    };

    const fetchTaxStructureByTaxTypeID = async(id) => {
        try {
            const master = await getTaxStructureByTaxTypeID(id)
            setAllTaxStructure(master);
            
        } catch (err) {
            swal.fire({ icon :'error', titleText : err.message })

        }
    };

    const clearAction = () => {       
        setTaxStructure({TaxTypeID: taxType.ID, Active: "Y"});
        setIsEdit(false);
    };

    
    const onCheck = async (value) => {
        postTaxStructureData(value, false);                        
    };

    return(
        <>
            <div className="kt-portlet__body padding-t20 padding-b0">
                <form className="kt-form sticky margin-b10 padding-t15 padding-b10 bg-white" id="addBlockForm" >                
                    <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 bv-form  " role="form">
                        <div className="form-group row mb-0">
                            <label className="col-form-label col-sm-1 text-right"> Name </label>
                            <div className="col-5 form-group">
                                <input 
                                    id="txtName" 
                                    name="txtName" 
                                    type="text" 
                                    className="form-control"
                                    value={taxStructure.Name || ''}
                                    onChange={(event) => dataHandler('Name',  helper.camelCase(event.target.value))} 
                                />
                            </div>
                            <label className="col-form-label col-lg-1">Description </label>
                            <div className="col-5 form-group">
                                <textarea 
                                    id="txtDescription" 
                                    name="txtDescription" 
                                    className="form-control" 
                                    rows="1"
                                    value={taxStructure.Description || ''}
                                    onChange={(event) => dataHandler('Description', event.target.value)} 
                                ></textarea>
                            </div>
                            <label className="col-form-label col-sm-1 text-right"> Tax </label>
                            <div className="col-5 form-group">
                                <div className="input-group timepicker">
                                    <input 
                                        id="txtTax" name="txtTax" type="number" className="form-control" 
                                        value={ taxStructure.Tax || '' }
                                        onChange={({target}) => dataHandler("Tax", target.value)} 
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <i className="fa fa-percentage"></i>
                                        </span>
                                    </div>
                                </div>                                      
                            </div>
                            <div className="col-1"></div>
                            <div className="col-sm-5" >
                                {(!isEdit) ? (
                                    <button id="btnAdd" type="button" className={`btn btn-label-brand d-inline-block margin-0 form-control`} onClick={() => postTaxStructureData(taxStructure)} ><i className="la la-plus"></i> Add </button>
                                ):(
                                    <div className="btn-group" style={{width: '100%'}}>
                                        <button id="btnUpdate" type="button" className={`btn btn-label-success d-inline-block margin-0`} style={{width: '75%'}} onClick={() =>postTaxStructureData(taxStructure)} > Update </button>
                                        <button id="btnCancel" type="button" className="btn btn-secondary" onClick={clearAction}> <i className="la la-times ml-1 font-16" > </i> </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
                <table id="table-block" className="table table-bordered table-hover margin-b30">
                    <thead className="light-grey-background">
                        <tr>
                            <th  width="20%" > Type </th>
                            <th  width="40%" > Description </th>
                            <th className="text-center" width="10%" > Tax </th>
                            <th className="text-center" width="10%" > Active </th>
                            <th  width="10%" >  </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(allTaxStructure.length > 0 ) ?
                            allTaxStructure.map((t,i) => {
                                return (
                                    <tr className="dragableRow" key={t.ID} data-id={t.ID}>
                                        <td width="20%">{t.Name}</td>
                                        <td width="40%">{t.Description}</td>
                                        <td width="10%">{t.Tax} %</td>
                                        <td className="text-center padding-b0" width="15%">
                                            <span className="kt-switch kt-switch--md kt-switch--icon margin-lr10">
                                                <label>
                                                    <input 
                                                        id="chkActive" 
                                                        name="chkActive" 
                                                        type="checkbox" 
                                                        defaultChecked={t.Active == 'N' ? '' : 'checked'}
                                                        onChange={(event) => onCheck({...t, Active: event.target.checked ? 'Y' : 'N'})} 
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </td>
                                        <td className="text-center" width="10%">
                                            <button type="button" disabled={isEdit} className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-block-edit" onClick={() => editHandler(t.ID)}><i className="flaticon2-edit"></i></button>
                                        </td>
                                    </tr>
                                )
                            }):
                            (
                            <tr>
                                <td colSpan={3}> 
                                    <div className="padding-10"> 
                                        <h5 className="text-center text-muted"> No Tax Structure..! </h5> 
                                    </div>
                                </td>
                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
};

export default StructureModal